import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../config/httpConfig";

export const getDashboardDetails = createAsyncThunk(
  "dashboard/getDashboardDetails",
  async ({ orgId, startDate, endDate }, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `/api/investor/getDashboardDetails?orgId=${orgId}&startDate=${startDate}&endDate=${endDate}`
      );

      return response.response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: {
    dashboardData: {},
    loading: false,
    error: null,
  },

  extraReducers: (builder) => {
    builder.addCase(getDashboardDetails.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getDashboardDetails.fulfilled, (state, action) => {
      state.loading = false;
      state.dashboardData = action.payload;
      state.error = null;
    });
    builder.addCase(getDashboardDetails.rejected, (state, action) => {
      state.loading = false;
      state.dashboardData = {};
      state.error = action.payload;
    });
  },
  reducers: {},
});

// eslint-disable-next-line no-empty-pattern
export const {} = dashboardSlice.actions;

export default dashboardSlice.reducer;
